<template>
  <div>
    <b-modal ref="padmin-restart-modal" class="padmin-modal" id="padmin-restart-modal-id" size="lg"
      hide-footer :title="$t('message.padmin_restart_required')" @hidden="clear" no-close-on-backdrop>

      <div v-if="restartResult">
        {{$t('message.page_reload_desc')}}
      </div>

      <ConsoleOutput v-if="restartResult != null" :result="restartResult" :output="restartOutput"/>

      <b-modal-footer>
        <b-button variant="secondary" @click="$refs['padmin-restart-modal'].hide()">
          {{$t('message.button_close') | title}}
        </b-button>
        <b-button variant="secondary" @click="pageReload" :disabled="padminReloadDisabled">
          {{$t('message.button_reload') | title}}
        </b-button>
        <b-button v-if="!restartResult" variant="danger" @click="restartPadmin" :disabled="restartInProgress">
          <b-spinner v-if="restartInProgress" small type="grow"/>
          {{$t('message.button_restart') | title}}
        </b-button>
      </b-modal-footer>
    </b-modal>

    <b-modal ref="shutdown-modal" class="padmin-modal" id="shutdown-modal-id" size="lg"
      hide-footer :title="$t('message.shutdown_required')" @hidden="clear" no-close-on-backdrop>

      <ActiveUsers :mins="10"/>

      <b-modal-footer>
        <b-button variant="secondary" @click="$refs['shutdown-modal'].hide()">
          {{$t('message.button_close') | title}}
        </b-button>
        <b-button variant="danger" @click="shutdown" :disabled="restartInProgress">
          <b-spinner v-if="restartInProgress" small type="grow"/>
          {{$t('message.button_shutdown') | title}}
        </b-button>
      </b-modal-footer>
    </b-modal>

    <b-modal ref="passman-restart-modal" class="padmin-modal" id="passman-restart-modal-id" size="lg"
      hide-footer :title="$t('message.passman_restart_required')" @hidden="clear" no-close-on-backdrop>

      <ActiveUsers :mins="10"/>

      <ConsoleOutput v-if="restartResult != null" :result="restartResult" :output="restartOutput"/>

      <b-modal-footer>
        <b-button variant="secondary" @click="$refs['passman-restart-modal'].hide()">
          {{$t('message.button_close') | title}}
        </b-button>
        <b-button v-if="!restartResult" variant="danger" @click="restartAgung" :disabled="restartInProgress">
          <b-spinner v-if="restartInProgress" small type="grow"/>
          {{$t('message.button_restart') | title}}
        </b-button>
      </b-modal-footer>
    </b-modal>

    <b-modal ref="reboot-local-modal" class="padmin-modal" id="reboot-local-modal-id" size="lg"
      hide-footer :title="$t('message.reboot_local_desc')" @hidden="clear" no-close-on-backdrop>

      <ActiveUsers :mins="10"/>

      <div v-if="restartResult">
        {{$t('message.page_reload_desc')}}
      </div>

      <ConsoleOutput v-if="restartResult != null" :result="restartResult" :output="restartOutput"/>

      <b-modal-footer>
        <b-button variant="secondary" @click="$refs['reboot-local-modal'].hide()">
          {{$t('message.button_close') | title}}
        </b-button>
        <b-button variant="secondary" @click="pageReload" :disabled="padminReloadDisabled">
          {{$t('message.button_reload') | title}}
        </b-button>
        <b-button variant="danger" @click="reboot_local" :disabled="restartInProgress">
          <b-spinner v-if="restartInProgress" small type="grow"/>
          {{$t('message.reboot_local_title') | title}}
        </b-button>
      </b-modal-footer>
    </b-modal>

  </div>
</template>

<script>
import {get, post} from '../http'
import ConsoleOutput from './ConsoleOutput'
import ActiveUsers from './ActiveUsers'

export default {
  name: 'RestartModal',

  components: {ConsoleOutput, ActiveUsers},

  data () {
    return {
      restartResult: null,
      restartOutput: '',
      restartInProgress: false,
      padminReloadDisabled: true
    }
  },

  methods: {
    restartAgung () {
      this.restartInProgress = true
      this.restartOutput = ''
      post('/restart_agung').then(resp => {
        this.restartResult = resp.data.result
        this.restartOutput = resp.data.output
        this.restartInProgress = false
      }, err => {
        console.log('err', err)
        this.restartInProgress = false
      })
    },

    restartPadmin () {
      this.restartInProgress = true
      this.restartOutput = ''
      post('/restart_padmin').then(resp => {
        this.restartInProgress = false
        this.enableReload(3000)
        if (resp.status == 502) {
          this.restartResult = true
        } else {
          this.restartResult = resp.data.result
          this.restartOutput = resp.data.output
        }
      }, err => {
        console.log('err', err)
        this.restartInProgress = false
        if (err.response.status == 502) {
          this.restartResult = true
          this.enableReload(2000)
        } else {
          this.restartResult = false
        }
      })
    },

    shutdown () {
      this.restartInProgress = true
      this.restartOutput = ''
      post('/shutdown').then(resp => {
        this.restartResult = resp.data.result
        this.restartOutput = resp.data.output
        this.restartInProgress = false
      }, err => {
        console.log('err', err)
        this.restartInProgress = false
      })
    },

    reboot_local () {
      get("/init").then(
        resp => {
          let rebootCmd = resp.data.mode == 'cluster' ? 'reboot_local' : 'reboot'
          this.restartInProgress = true
          this.restartOutput = ''
          this.enableReload(4000)
          post('/scripts/services/' + rebootCmd).then(resp => {
            this.restartResult = resp.data.result
            this.restartOutput = resp.data.output
            this.restartInProgress = false
          }, err => {
            console.log('err', err)
            // hopefully reboot succeeded
            this.restartResult = true
            this.enableReload(4000)
            this.restartInProgress = false
          })
        },
        error => {
          console.log("get init conf failed", error)
        }
      )
    },

    clear () {
      this.restartResult = null
      this.restartOutput = ''
      this.restartInProgress = false
    },

    enableReload(time_ms) {
      setTimeout(() => { this.padminReloadDisabled = false }, time_ms)
    },

    pageReload() {
      window.location.reload()
    }

  }
}
</script>
<style scoped>
.padmin-modal .output{
  width:100% !important;
  margin:10px !important;
}
</style>
